import { createReducer } from 'utils/simpleDataReducer'

import agreementsActions from './actions'

export default createReducer(agreementsActions)
